// SelectOneInput.jsx
import {
    Box,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Tooltip,
    FormHelperText,
    Grid,
    Alert,
} from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";

const SelectOneInput = ({
                            field,
                            value,
                            onChange,
                            parentSection,
                            error,
                            helperText,
                            disabled,
                        }) => {
    const selected = value ?? "";
    const { t } = useTranslation();

    const options = field.fields || [];
    const selectedOpt = options.find((opt) => String(opt.value) === String(selected));
    const selectedInfo = selectedOpt?.info ? t(selectedOpt.info) : "";

    return (
        <FormControl fullWidth error={error} sx={{ mt: 2 }}>
            <RadioGroup
                value={selected}
                onChange={(_, newValue) => onChange(field.id, newValue, parentSection)}
            >
                <Grid container spacing={2}>
                    {options.map((opt, idx) => (
                        <Grid item xs={12} sm={6} md={4} key={String(opt.value ?? idx)}>
                            <FormControlLabel
                                value={String(opt.value)}
                                disabled={opt.disabled || disabled}
                                control={<Radio />}
                                label={
                                    <Box display="inline-flex" alignItems="center">
                                        <span>{t(opt.label)}</span>
                                        {opt.tooltip && (
                                            <Tooltip title={t(opt.tooltip)} arrow>
                                                <InfoOutlined
                                                    fontSize="small"
                                                    color="action"
                                                    sx={{ ml: 0.5, cursor: "help" }}
                                                />
                                            </Tooltip>
                                        )}
                                    </Box>
                                }
                            />
                        </Grid>
                    ))}
                </Grid>
            </RadioGroup>

            {!!selectedInfo && (
                <Alert severity="info" sx={{ mt: 1 }}>
                    {selectedInfo}
                </Alert>
            )}

            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default SelectOneInput;
